import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/order.service';
import { Store } from 'src/app/models/store';
import { LoyaltyPointService } from 'src/app/_services/loyalty-point.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-redeem-history',
  templateUrl: './redeem-history.component.html',
  styleUrls: ['./redeem-history.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedeemHistoryComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
    private loyaltyPointService: LoyaltyPointService,
    private cdr: ChangeDetectorRef
  ) {}

  /* =====================
   * BASIC STATE
   * ===================== */
  isLoading = false;

  hash!: string;
  storeId!: string;
  storeid!: string;

  store: Store | null = null;

  /* =====================
   * DATA
   * ===================== */
  offerRedeemHistory: any[] = [];
  loyaltyRedeemHistory: any[] = [];

  /* =====================
   * PAGINATION (LOYALTY)
   * ===================== */
  page = 1;
  pageSize = 10;
  hasMore = true;

  ngOnInit(): void {
    this.hash = this.route.snapshot.paramMap.get('hash')!;
    this.storeId = this.route.snapshot.paramMap.get('storeId')!;
    this.storeid = localStorage.getItem('currentStore')!;

    this.loadStore();
    this.loadOfferRedeemHistory();
    this.loadLoyaltyRedeemHistory(true);
  }

  /* =====================
   * STORE
   * ===================== */
  private loadStore(): void {
    this.orderService.getStoreInfo(this.storeId).subscribe({
      next: (store) => {
        this.store = Object.assign(new Store(), store);
        this.cdr.markForCheck();
      },
      error: () => {
        this.store = null;
        this.cdr.markForCheck();
      }
    });
  }

  /* =====================
   * OFFER REDEEMS
   * ===================== */
  private loadOfferRedeemHistory(): void {
    this.isLoading = true;

    this.orderService.redeemHistoryAll(this.hash).subscribe({
      next: (data: any[]) => {
        this.offerRedeemHistory = data || [];
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.offerRedeemHistory = [];
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  /* =====================
   * LOYALTY REDEEMS
   * ===================== */
  loadLoyaltyRedeemHistory(reset = false): void {

    if (reset) {
      this.page = 1;
      this.loyaltyRedeemHistory = [];
      this.hasMore = true;
    }

    if (!this.hasMore || this.isLoading) return;

    this.isLoading = true;

    this.loyaltyPointService
      .getPointRedeemHistory(
        this.storeid,
        this.hash,
        this.page,
        this.pageSize,
        'redeemed'
      )
      .subscribe({
        next: (data: any) => {
          const rows = data.data || [];
          this.loyaltyRedeemHistory.push(...rows);
          this.hasMore = rows.length === this.pageSize;
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.hasMore = false;
          this.isLoading = false;
          this.cdr.markForCheck();
        }
      });
  }

  loadMoreLoyalty(): void {
    this.page++;
    this.loadLoyaltyRedeemHistory();
  }

  /* =====================
   * NAV
   * ===================== */
  goTo(item: any): void {
    this.router.navigate([
      this.hash,
      'my-offers',
      item.offer_item.id,
      'redeem',
      item.id,
      'status'
    ]);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack(): void {
    window.history.back();
  }
}
